import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { startDeploymentRefreshChecks } from "./lib/deploymentRefresh";
import "./styles.css";
import { initializeAutomaticReload } from "./lib/automaticReload";

initializeAutomaticReload();

createRoot(document.getElementById("root")!).render(
  <StrictMode><App /></StrictMode>
);

async function removeLegacyServiceWorkerData() {
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));

  if ("caches" in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
  }
}

if (import.meta.env.PROD) {
  window.addEventListener("load", () => {
    if ("serviceWorker" in navigator) {
      removeLegacyServiceWorkerData().catch((error) => console.error("Legacy service worker cleanup failed:", error));
    }
    startDeploymentRefreshChecks();
  }, { once: true });
}
